import { get } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const GET_PROPERTY_LIST_REQUEST = 'GET_PROPERTY_LIST_REQUEST';
const GET_PROPERTY_LIST_SUCCESS = 'GET_PROPERTY_LIST_SUCCESS';
const GET_PROPERTY_LIST_ERROR = 'GET_PROPERTY_LIST_ERROR';
const GET_TOTAL_PORTFOLIO_VIOLATIONS_REQUEST =
	'GET_TOTAL_PORTFOLIO_VIOLATIONS_REQUEST';
const GET_TOTAL_PORTFOLIO_VIOLATIONS_SUCCESS =
	'GET_TOTAL_PORTFOLIO_VIOLATIONS_SUCCESS';
const GET_TOTAL_PORTFOLIO_VIOLATIONS_ERROR =
	'GET_TOTAL_PORTFOLIO_VIOLATIONS_ERROR';

const initialState = {
	propertyList: null,
	totalViolations: {},
	isLoading: false,
	isLoadingViolations: false,
	error: null,
	errorTotalViolations: null,
};

export const getPropertyList =
	(userId, sort = 'address|asc') =>
	(dispatch, getState) => {
		let state = getState();
		let url = `${API_URL}/api/portfolio/${userId}?sort=${sort}&per_page=${99999}`;
		dispatch(getPropertyListRequest());
		return get({
			dispatch,
			url,
			authToken: state.user.authToken,
			onSuccess: (result) => {
				return dispatch(getPropertyListSuccess(result));
			},
			onError: (error) => dispatch(getPropertyListError(error)),
		});
	};

export const getTotalPortfolioViolations = (userId) => (dispatch, getState) => {
	let state = getState();
	let url = `${API_URL}/api/num-open-violations`;
	dispatch(getTotalPortfolioViolationsRequest());
	return get({
		dispatch,
		url,
		authToken: state.user.authToken,
		onSuccess: (result) => {
			return dispatch(getTotalPortfolioViolationsSuccess(result));
		},
		onError: (error) => dispatch(getTotalPortfolioViolationsError(error)),
	});
};

export const getPropertyListRequest = () => ({
	type: GET_PROPERTY_LIST_REQUEST,
	payload: {
		isLoading: true,
		propertyList: null,
	},
});

export const getPropertyListSuccess = (data) => ({
	type: GET_PROPERTY_LIST_SUCCESS,
	payload: {
		isLoading: false,
		propertyList: data,
		error: null,
	},
});

export const getPropertyListError = (error) => ({
	type: GET_PROPERTY_LIST_ERROR,
	payload: {
		isLoading: false,
		propertyList: null,
		error: error,
	},
});

export const getTotalPortfolioViolationsRequest = () => ({
	type: GET_TOTAL_PORTFOLIO_VIOLATIONS_REQUEST,
	payload: {
		isLoadingViolations: true,
	},
});

export const getTotalPortfolioViolationsSuccess = (data) => ({
	type: GET_TOTAL_PORTFOLIO_VIOLATIONS_SUCCESS,
	payload: {
		isLoadingViolations: false,
		totalViolations: data,
		errorTotalViolations: null,
	},
});

export const getTotalPortfolioViolationsError = (error) => ({
	type: GET_TOTAL_PORTFOLIO_VIOLATIONS_ERROR,
	payload: {
		isLoadingViolations: false,
		totalViolations: {},
		errorTotalViolations: error,
	},
});

const propertyListReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PROPERTY_LIST_REQUEST:
		case GET_PROPERTY_LIST_SUCCESS:
		case GET_PROPERTY_LIST_ERROR:
		case GET_TOTAL_PORTFOLIO_VIOLATIONS_REQUEST:
		case GET_TOTAL_PORTFOLIO_VIOLATIONS_SUCCESS:
		case GET_TOTAL_PORTFOLIO_VIOLATIONS_ERROR:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export default propertyListReducer;
